import useSWRMutation from "swr/mutation";

import { MUTATION_OPTIONS, postJSONWithCSRF } from "@/utils/swr";

import { CYO_ERRORS } from "./constants";

interface CYOResponseData {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  created_at: string;
}

interface CYOCreateResponse {
  data: CYOResponseData;
  errors: string[];
}

const API_URL = "/api/enquiries_new";

const postCYO = postJSONWithCSRF<CYOCreateResponse>(CYO_ERRORS.GENERIC_ERROR, {
  createBody: ({ arg }) => JSON.stringify(arg),
  csrfTokenStrategy: "metaOnly",
});

export const useCYOQuery = (params?: {
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const { onSuccess, onError } = params ?? {};
  const { trigger, error, isMutating } = useSWRMutation(API_URL, postCYO, {
    ...MUTATION_OPTIONS,
    onSuccess,
    onError,
  });

  return {
    CYOError: error,
    isSubmittingCYO: isMutating,
    submitCYO: trigger,
  };
};
